import { render, staticRenderFns } from "./customerAccount.vue?vue&type=template&id=fa165fe2&scoped=true&"
import script from "./customerAccount.vue?vue&type=script&lang=js&"
export * from "./customerAccount.vue?vue&type=script&lang=js&"
import style0 from "./customerAccount.vue?vue&type=style&index=0&id=fa165fe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa165fe2",
  null
  
)

export default component.exports